import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { sortData } from "../../utils/commonMethods";

import CustomDataTable from "../../components/datatable/customDataTable";

import ICNoImg from "../../assets/images/default-picture.png";

const DoctorBlockedBy = props => {
  const [patList, setpatList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });

  const filterPatList = () => {
    let newList = patList.slice(
      currFilters.skip,
      currFilters.skip + currFilters.limit
    );
    setFilteredList(newList);
  };

  useEffect(() => {
    let list = [];

    props.data.forEach(item => {
      let temp = item.patientId;
      let d = {};
      d.patientId = temp.patientId;
      d.fullname = temp.firstName;
      if (temp.middleName !== "") {
        d.fullname = d.fullname + " " + temp.middleName;
      }
      d.fullname = d.fullname + " " + temp.lastName;
      d.profilePic = temp.profilePic;
      list.push(d);
    });

    setpatList(list);
    setFilteredList(list);
    setTotalRecords(props.data.length);
  }, [props.data]);

  useEffect(() => {
    filterPatList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const tableHeaders = [
    {
      key: "patientPic",
      value: "Profile Pic",
      sort: false
    },
    {
      key: "patientId",
      value: "Patient's UIN"
    },
    {
      key: "fullname",
      value: "Patient's Name"
    }
  ];

  const setTableFilters = filters => {
    if (filters.text && filters.text.length > 0) {
      customSearchTableByText(filters.text);
    } else {
      let newFilter = Object.assign({}, currFilters);
      newFilter.limit = parseInt(filters.limit);
      newFilter.skip = parseInt(filters.skip);

      setCurrFilters(newFilter);
    }
  };

  // create custom table filter function
  const customSearchTableByText = query => {
    let newFilteredList = patList.filter(item => {
      if (item.patientId.includes(query)) {
        return true;
      } else if (item.fullname.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }

      return false;
    });

    setFilteredList(newFilteredList);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, filteredList);
    setFilteredList(sortedData);
  };

  return (
    <div className="view-ticket-container mb-0 pb-0">
      <CustomDataTable
        totalRecords={totalRecords}
        headers={tableHeaders}
        setFilters={setTableFilters}
        sortData={sortTableDataByColumn}
        tabFilters={currFilters}
        disbleAll={true}
      >
        {filteredList.map((pat, index) => (
          <tr key={index}>
            <td>
              <img
                className="rounded-circle user-img"
                src={
                  pat.profilePic &&
                  pat.profilePic.original !== undefined &&
                  pat.profilePic.original !== null
                    ? pat.profilePic.original
                    : ICNoImg
                }
                alt="doc-pic"
              />
            </td>
            <td>{pat.patientId}</td>
            <td>{pat.fullname}</td>
          </tr>
        ))}
      </CustomDataTable>
    </div>
  );
};

export default DoctorBlockedBy;

DoctorBlockedBy.defaultProps = {
  data: []
};

DoctorBlockedBy.propTypes = {
  data: PropTypes.array.isRequired
};
